import { render, staticRenderFns } from "./AddAlbumModal.vue?vue&type=template&id=ac305ef6"
import script from "./AddAlbumModal.vue?vue&type=script&lang=js"
export * from "./AddAlbumModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports